import uuidv4 from 'uuid/v4';
import download from 'downloadjs';
import {
  take,
  put,
  select,
  takeLatest,
  race,
  all,
  call,
  fork,
} from 'redux-saga/effects';
import _ from 'lodash';
import { BANNER_TO_SHOW } from '../../../actions/appActions';
import { FRAME_APP_MOUNTED } from '../../../actions/frameActions';
import {
  EMMA_EB_FLEXI_POPUP,
  UPDATE_EB_FLEXI_LOADING,
  FETCH_EB_FLEXI_SUCCESS,
  FETCH_EB_FLEXI_DATA,
  UPDATE_EB_FLEXI_TOKEN,
  GO_TO_REDIRECT,
  EB_FLEXI_HIDE_LOADING_BTN,
} from '../actions/ebFlexiActions';
import {
  getEbFlexiAccessToken,
  getEbFlexiApi,
  getPolicyCard,
} from '../selectors/ebFlexiSelectors';
import {
  fetchWithTimeout,
  myAxaFetchWithToken,
} from '../../../utils/myAxaFetchWithToken';
import HomePagePopUpRegistry from '../../../registries/HomePagePopUpRegistry';
import { EMMA_EB_FLEXI } from '../../../constants/constants';
import { showErrorModal } from '../../../actions/uiActions';
import { getBaseUrl, isApp, joinPath, stringFormatter } from '../../../utils';
import { fetchContentoAvators } from '../../home/saga/homeSaga';
import { getRefreshToken, getToken } from '../../../selectors/authSelectors';
import { getLanguage } from '../../../selectors/userSelectors';
import { getValidToken } from '../../../utils/index';
import { getApiKey } from '../../../selectors/configSelectors';
import { goto } from '../../../actions/historyActions';
import { PostMsgParams } from '../../partners/types/partnerTypes';
import { REDIRECT_ACTION } from '../../partners/actions';

function* goToRedirect(): any {
  try {
    const policyCard = yield select(getPolicyCard);
    const access_token = yield select(getEbFlexiAccessToken);
    const { policyNumber, certificateNumber } = policyCard;
    const postEbFlexParams: PostMsgParams = {};
    postEbFlexParams.action = REDIRECT_ACTION;
    postEbFlexParams.params = {};
    postEbFlexParams.params['access_token'] = access_token;
    postEbFlexParams.params['policy_number'] = policyNumber;
    postEbFlexParams.params['certificate_number'] = certificateNumber;
    const absUrl = 'eb-flexi-redirect';
    yield call(goto, absUrl, undefined, postEbFlexParams);
  } catch (e) {
    yield put(showErrorModal());
  }
}

function* getEbFlexiData(action: any): any {
  try {
    // emma-web's EBFlexi should not serve for app webview
    if (isApp()) {
      return;
    }
    if (action && action.type === FETCH_EB_FLEXI_DATA) {
      yield fork(fetchContentoAvators);
    }
    const ebFlexiUrl = yield select(getEbFlexiApi);
    const lang = yield select(getLanguage);
    if (!ebFlexiUrl) {
      return;
    }

    yield put({ type: UPDATE_EB_FLEXI_LOADING, isLoading: true });

    const res = yield call(myAxaFetchWithToken, ebFlexiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-axahk-msgid': uuidv4(),
      },
    });

    // mock data
    // const res = { status: 200, json: () => require('../../../mock/ebFlexi.json') }

    const data = yield res.json();
    const response = _.get(data, 'retrieveFlexiPermissionResponse', {});
    const { policyNumber, certificateNumber, policyName } = response;
    const planName = policyName && policyName[lang];
    if (policyNumber) {
      const returnData = {
        isShowBanner: policyNumber ? true : false,
        ebFlexiOverlayShow: policyNumber ? true : false,
        policyCard: {
          planName,
          policyNumber,
          certificateNumber,
          isSelected: true,
        },
      };
      yield HomePagePopUpRegistry.setFetchDataCompleted(EMMA_EB_FLEXI, true);
      yield put({ type: FETCH_EB_FLEXI_SUCCESS, ...returnData });
    } else {
      yield HomePagePopUpRegistry.setFetchDataCompleted(EMMA_EB_FLEXI);
    }
    yield put({ type: UPDATE_EB_FLEXI_LOADING, isLoading: false });
  } catch (e) {
    yield put({ type: UPDATE_EB_FLEXI_LOADING, isLoading: false });
    yield HomePagePopUpRegistry.setFetchDataCompleted(EMMA_EB_FLEXI);
    yield put(showErrorModal());
  }
}

function* setShowPopup(): Iterable<any> {
  while (true) {
    yield take(BANNER_TO_SHOW);
    const isShowPopup = HomePagePopUpRegistry.getIsDisplay(EMMA_EB_FLEXI);
    if (isShowPopup) {
      yield put({ type: EMMA_EB_FLEXI_POPUP, isShowPopupModal: true });
    }
  }
}

function* ebFlexiSaga() {
  yield takeLatest(FETCH_EB_FLEXI_DATA, getEbFlexiData);
  yield takeLatest(FRAME_APP_MOUNTED, getEbFlexiData);
  yield takeLatest(GO_TO_REDIRECT, goToRedirect);
  yield take(FRAME_APP_MOUNTED);
  yield fork(setShowPopup);
}

export default ebFlexiSaga;
